<template>
  <urun-areas-layout>
    <div>
      <div class="mb-3">
        <div>
          <panel-title
            icon="mdi-label"
            :title="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.TITLE')"
            :desc="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.SUB_TITLE')"
          >
            <template v-slot:append-inner>
              <v-btn color="grey darken-3" class="text-capitalize" small dark @click="nitelikEkleDialog.dialog = true">
                <v-icon size="16" class="mr-1">mdi-plus-circle</v-icon>
                {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.ADD_QUALIFICATION_BTN") }}
              </v-btn>
            </template>
          </panel-title>
        </div>
      </div>
      <div v-if="nitelikler.length">
        <div :key="key" v-for="(nitelik, key) in nitelikler">
          <v-card class="px-4 py-4">
            <div class="mb-3">
              <p class="text-subtitle-2 mb-0 d-flex align-center">
                <v-icon color="grey darken-3" class="mr-1" size="18">mdi-checkbox-multiple-blank</v-icon>
                {{ nitelik.name }}
                <v-spacer></v-spacer>
                <v-btn x-small color="info" class="mr-2" @click="nitelikDuzenle(nitelik.code)">
                  <v-icon size="16" class="mr-1">mdi-pencil</v-icon>
                  {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.EDIT_QUALIFICATION_BTN") }}
                </v-btn>
                <v-btn x-small color="error" @click="nitelikKaldirDialog(nitelik.code)">
                  <v-icon size="16" class="mr-1">mdi-delete-outline</v-icon>
                  {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.DELETE_QUALIFICATION_BTN") }}
                </v-btn>
              </p>
            </div>
            <div>
              <v-chip label color="grey darken-4" dark class="mr-2 mb-2" :key="xkey" v-for="(item, xkey) in nitelik.items">{{ item.name }} </v-chip>
            </div>
          </v-card>
          <v-divider class="my-4" v-show="nitelikler.length - 1 !== key"></v-divider>
        </div>
      </div>
      <div v-else-if="niteliklerStatus === true">
        <v-skeleton-loader :key="key" v-for="key in 3" class="mb-4" elevation="1" type="article"></v-skeleton-loader>
      </div>
      <div v-else>
        <p class="body-2 font-weight-medium text-center grey--text text--darken-1 py-3 px-3 grey lighten-2">
          {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.NO_QUALIFICATION_ADDITIONAL") }}
        </p>
      </div>
    </div>
    <!--  Nitelik Ekle Dialog  -->
    <v-dialog v-model="nitelikEkleDialog.dialog" max-width="800">
      <v-card>
        <v-card-title class="subtitle-1">
          <v-icon color="black" class="mr-2" size="20">
            mdi-plus-circle
          </v-icon>
          {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.ADD_QUALIFICATION_DIALOG.TITLE") }}
          <v-spacer></v-spacer>
          <v-btn icon @click="nitelikEkleDialogKapat">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="grey lighten-2 pt-5">
          <v-text-field
            prepend-inner-icon="mdi-arrow-right-thick"
            solo
            :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.ADD_QUALIFICATION_DIALOG.QUALIFICATION_NAME_LABEL')"
            hide-details
            class="mb-3"
            v-model="nitelikEkleDialog.data.name"
          ></v-text-field>
          <urun-nitelik-ekle
            :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.ADD_QUALIFICATION_DIALOG.QUALIFICATION_ITEMS_LABEL')"
            :hint="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.ADD_QUALIFICATION_DIALOG.QUALIFICATION_ITEMS_HINT')"
            v-model="nitelikEkleDialog.data.value"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark small color="blue darken-2" class="px-3" @click="nitelikTanimla" :loading="nitelikEkleDialog.loading">
            <v-icon size="18" class="mr-1">mdi-plus-circle</v-icon>
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.ADD_QUALIFICATION_DIALOG.ADD_BTN") }}
          </v-btn>
          <v-btn dark color="red darken-2" small @click="nitelikEkleDialogKapat">
            <v-icon class="mr-1" size="18">mdi-close</v-icon>
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.ADD_QUALIFICATION_DIALOG.CLOSE_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  ./Nitelik Ekle Dialog  -->

    <!-- <urun-nitelik-ekle v-model="nitelikEkleDialog.dialog" /> -->
    <v-dialog v-model="nitelikKaldirData.dialog" max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
          {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.DELETE_QUALIFICATION_DIALOG.TITLE") }}
        </v-card-title>
        <v-card-text>
          {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.DELETE_QUALIFICATION_DIALOG.INFO_CONTENT") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="nitelikKaldirData.dialog = false">
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.DELETE_QUALIFICATION_DIALOG.CLOSE_BTN") }}
          </v-btn>
          <v-btn color="green darken-1" text :loading="nitelikKaldirData.loading" @click="nitelikKaldir()">
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.DELETE_QUALIFICATION_DIALOG.YES_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <urun-nitelik-duzenle v-model="nitelikDuzenleDialog.dialog" :data="nitelikDuzenleDialog.data" @changed="nitelikListesi" />
  </urun-areas-layout>
</template>

<script>
import PanelTitle from "../../../../components/PanelTitle.vue";
import UrunAreasLayout from "./UrunAreasLayout.vue";
import UrunlerService from "@/services/UrunlerService";
import UrunNitelikDuzenle from "../../../../components/Modules/Urunler/UrunNitelikDuzenle.vue";
import UrunNitelikEkle from "../../../../components/Modules/Urunler/UrunNitelikEkle.vue";

export default {
  components: {
    PanelTitle,
    UrunNitelikEkle,
    UrunAreasLayout,
    UrunNitelikDuzenle
  },
  name: "UrunNitelikler",
  data: () => ({
    data: {
      name: "Boyutlar"
    },
    nitelikler: [],
    niteliklerStatus: false,
    nitelikEkleDialog: {
      dialog: false,
      loading: false,
      data: {
        name: "",
        value: []
      }
    },
    nitelikDuzenleDialog: {
      dialog: false,
      loading: false,
      data: {
        code: 0,
        name: "",
        value: []
      }
    },
    nitelikKaldirData: {
      dialog: false,
      code: 0,
      loading: false
    },
    duzenleListActivator: false
  }),
  methods: {
    nitelikListesi() {
      this.niteliklerStatus = true;
      UrunlerService.nitelikListesi()
        .then(res => {
          if (res.status === 200) {
            this.nitelikler = res.data;
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.niteliklerStatus = false;
        });
    },
    nitelikTanimla() {
      let nitelikAdi = this.nitelikEkleDialog.data.name,
        nitelikler = this.nitelikEkleDialog.data.value;
      this.nitelikEkleDialog.loading = true;
      UrunlerService.nitelikTanimla({ nitelikAdi, nitelikler })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("URUNLER.NOTIFY.PRODUCT_QUALIFICATIONS.QUALIFICATION_ADD_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.nitelikEkleDialogKapat();
            this.nitelikListesi();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.nitelikEkleDialog.loading = false;
        });
    },
    nitelikDuzenle(nitelikCode) {
      let nitelik = this.nitelikler.find(o => o.code === nitelikCode);

      this.nitelikDuzenleDialog.data.code = nitelik.code;
      this.nitelikDuzenleDialog.data.name = nitelik.name;
      this.nitelikDuzenleDialog.data.value = nitelik.items;

      this.nitelikDuzenleDialog.data = JSON.parse(JSON.stringify(this.nitelikDuzenleDialog.data));

      this.nitelikDuzenleDialog.dialog = true;
    },
    nitelikEkleDialogKapat() {
      this.$set(this.nitelikEkleDialog, "dialog", false);
      this.$set(this.nitelikEkleDialog.data, "name", "");
      this.$set(this.nitelikEkleDialog.data, "value", []);
    },
    nitelikDuzenleDialogKapat() {
      this.$set(this.nitelikDuzenleDialog, "dialog", false);
      this.$set(this.nitelikDuzenleDialog.data, "name", "");
      this.$set(this.nitelikDuzenleDialog.data, "value", []);
    },
    nitelikKaldirDialog(nitelikCode) {
      this.nitelikKaldirData.code = nitelikCode;
      this.nitelikKaldirData.dialog = true;
    },
    nitelikKaldir() {
      const nitelikCode = this.nitelikKaldirData.code;
      this.nitelikKaldirData.loading = true;
      UrunlerService.nitelikKaldir(nitelikCode)
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("URUNLER.NOTIFY.PRODUCT_QUALIFICATIONS.QUALIFICATION_REMOVE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.nitelikKaldirData.dialog = false;
            this.nitelikListesi();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.nitelikKaldirData.loading = false;
        });
    }
  },
  created() {
    this.nitelikListesi();
  }
};
</script>

<style></style>
